import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./MembersOnlyGame.scss";
import { toast } from "react-toastify";
import areanaImg from "../../../../../assets/areanaDefault.png";
import UserContext from "../../../../../context/UserContext";
import NoGames from "../../../Comp/NoGames";
import LocationDropdown from "../../../VenueListComp/LocationDropdown";
import SportDrop from "../../../VenueListComp/SportDrop";
import Loader from "../../../../../components/Loader/Loader";

function MembersOnlyGame() {
  const navigate = useNavigate();
  const { userDetail } = useContext(UserContext);

  // State for dropdowns
  const [location, setLocation] = useState("Chennai");
  const [sport, setSport] = useState("all");
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Static options for dropdowns
  const locationOptions = [
    "Bangalore",
    "Chennai",
    "Delhi",
    "Dubai",
    "Hyderabad",
    "Mumbai",
    "Pune",
  ].sort(); // Sort alphabetically
  const sportOptions = [
    "ALL",
    "Cricket",
    "Padel",
    "Football",
    "Badminton",
    "Tennis",
    "Pickleball",
    "Table Tennis",
  ];

  // Fetch games from API
  const fetchGames = async () => {
    setLoading(true);
    setError(null);

    const url =
      "https://ballersapi.ballerslife.co/api/v1/memberships/bookings/get_all_active_games_overview";
    const accessToken = window.localStorage.getItem("access_token");

    const body = {
      city: location.toLowerCase(),
      sports: sport === "all" ? [] : [sport.toLowerCase()],
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();
      console.log(data, "API Response Data");
      if (response.status === 200) {
        // Map the API response to the format expected by the component
        const mappedGames = data.map((game) => ({
          id: game.booking_id,
          facility_id: game.facility_id,
          name: game.facility_name,
          location: `${game.locality}, ${
            game.city.charAt(0).toUpperCase() + game.city.slice(1)
          }`,
          sport: game.sport.charAt(0).toUpperCase() + game.sport.slice(1), // Capitalize sport
          players: `${game.players_joined}/${game.players_req}`,
          time: game.booking_time,
          date: game.booking_date,
          image: game.facility_image || areanaImg,
        }));
        console.log(mappedGames, " Mapped Games");
        setGames(mappedGames);
      } else {
        setGames([]);
        // setError("Failed to fetch games. Please try again.");
        // toast.error(data.detail || "Failed to fetch games.");
      }
    } catch (err) {
      // setError("An error occurred while fetching games.");
      // toast.error("An error occurred while fetching games.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch games when location or sport changes
  useEffect(() => {
    document.title = ` Join Game | Ballers`;
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    fetchGames();
  }, [location, sport]);

  // Handle card click to navigate to details page
  const handleCardClick = (booking_id) => {
    navigate(`/dashboard/joingameDetails/${booking_id}`);
  };

  return (
    <div className="games-for-member">
      {/* Header Section */}
      <div className="header">
        <p className="greeting">Hi {userDetail?.member_name || "User"},</p>
        <div className="filters">
          <div className="dropdown">
            <label>Location:</label>
            <LocationDropdown
              location={location}
              setLocation={setLocation}
              locationOptions={["Chennai", "Mumbai", "Delhi"]}
            />
          </div>
          <div className="dropdownSec">
            <label>Sports:</label>
            <SportDrop
              sport={sport}
              setSport={setSport}
              // sportOptions={["badminton", "pickleball", "tennis", "football"]}
              sportOptions={["pickleball", "badminton"]}
            />
          </div>
        </div>
      </div>

      {/* Games Grid */}
      {console.log(games, "Games Length")}
      {loading ? (
        <Loader />
      ) : error ? (
        <p>{error}</p>
      ) : games.length > 0 ? (
        <div className="games-grid">
          {console.log(games, "Games Data")}
          {games.map((game) => (
            <div
              key={game.id}
              className="game-card"
              onClick={() => handleCardClick(game.id)}
              style={{ cursor: "pointer" }}
            >
              <img src={game.image} alt={game.name} className="game-image" />
              <div className="game-info">
                <h3 className="game-name">{game.name}</h3>
                <p className="game-location">{game.location}</p>
                <div className="game-details">
                  <div className="game-meta">
                    <span className="game-sport">
                      <span className="target-icon"></span>
                      {game.sport}
                    </span>
                    <span className="game-players">
                      <span className="person-icon"></span>
                      {game.players}
                    </span>
                  </div>
                  <div className="game-metaSec">
                    <span className="game-time">
                      <span className="clock-icon"></span>
                      {game.time}
                    </span>
                    <span className="game-date">
                      <span className="calendar-icon"></span>
                      {game.date}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <NoGames />
      )}
    </div>
  );
}

export default MembersOnlyGame;
